import { cn, HeaderContainer, HeaderTitle } from 'twyne-new.ui';

import { useGrid } from '../Grid';

import ButtonCollapse from './ButtonCollapse';

export default function HeaderContainerGrid({ title, children, titleClass = '', className = '' }) {
  const grid = useGrid()
  const renderButtonCollapse = !grid?.definitions ? true : grid.definitions.menuToggle !== undefined ? grid.definitions.menuToggle : true

  return <>
    <HeaderContainer className={cn('max-md:[&:has(.search-focused)_h1]:hidden', className)}>
      <div className='justify-between items-center gap-4 flex'>
        {renderButtonCollapse && <ButtonCollapse />}
        <HeaderTitle className={titleClass}>
          {title}
        </HeaderTitle>
      </div>
      {children}
    </HeaderContainer>
  </>
}
